/* eslint-disable react/no-deprecated */

/**
 * We are disabling the react/no-deprecated,
 * because the bellowing code is used in integration,
 * and we are not ready yet to upgrade to ES 6 syntax.
 */


import React from 'react';
import { map }from 'lodash';
import tsRest from 'ts-rest-client';

const createClass = require('create-react-class');

export const RepresentationType = createClass({
    displayName: "RepresentationType",
    
    getInitialState() {
        return {
            representationtypes:null
        };
    },

    componentWillMount: function() {
        this.loadRepresentationType();
    },

    loadRepresentationType: function() {
        this.repTypeReq = tsRest.get("/pos/23/representationtypes/eventcount");

        this.repTypeReq
            .done(function(representationtypes){
                this.setState({ representationtypes: representationtypes });
            }.bind(this), function(err) {
                this.setState({ ts: null });
                return tsRest.handleError(err);
            }.bind(this));
    },

    componentWillUnmount: function() {
        if(this.repTypeReq) this.repTypeReq.abort();
    },

    render() {
        let allRepList = null;
        if(this.state.representationtypes)
            allRepList = map(this.state.representationtypes, function(representationtype) {
                    const link = "/home?reptypeid=" + representationtype.ID;
                    return <li key={representationtype.ID}><a href={link}>{representationtype.Name}</a></li>;
                });

        return (
            <div className="col-xs-12 text-right menu smaller-status">
                <ul className="list-inline text-uppercase">
                    {allRepList}
                </ul>
            </div>
        );
    }
});
